<template>
  <div id="home" class="row">
      <Header />
      <div class="col-md-1">
      </div>
      <div class="col-md-10 home-container">
        <div class="row">
          <div class="col-md-12">
            <h3 class="text-center">{{translation.homePage.servicesTitle}}</h3>
            <div class="paragraf">
              {{translation.homePage.firstParagraf}}
            </div>
          </div>
          <div class="presentation-video-presentation col-md-12">
            <video  src="../assets/videos/my_epet_video.mp4" width="640" height="360" controls poster="../assets/img/icons/logo.svg">

            </video>
          <!-- <iframe src="https://www.youtube.com/embed/E1GiMCB7uFw" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
          </div>
          <div id="services" class="col-md-12 first-paw">
            <h3 class="text-left">{{translation.homePage.services}}</h3>
            <img class="img-responsive paw" src="../assets/img/icons/green-paw.svg" width="640" height="360" alt="First Image">
          </div>
        </div>
      </div>
      <div class="col-md-1"></div>
      <div class="services col-md-12">
        <div class="row">
          <div class="col-md-12 remove-padding second-paw">
            <div class="row">
              <div class="col-md-2 remove-padding first-service text-left">
                <img class="img-responsive" src="../assets/img/backgrounds/01.webp" width="640" height="360" alt="Paw">
              </div>
              <div class="col-md-5">
                <h4 class="text-left">{{translation.homePage.reviewTitle}}</h4>
                <div class="text-left">
                  {{translation.homePage.reviewMessage}}
                </div>
              </div>
              <div class="col-md-5">
                <h4 class="text-left">{{translation.homePage.vets}}</h4>
                <div class="text-left">
                  {{translation.homePage.vetsMessage}}
                </div>
              </div>
              <div class="col-sm-12">
                <img class="img-responsive paw" src="../assets/img/icons/blue-paw.svg" width="640" height="360" alt="Paw">
              </div>

            </div>
          </div>
          <div class="col-md-12 second-service remove-right-padding remove-padding">
            <div class="row">
              <div class="col-md-4 remove-padding text-left">
                <img class="img-responsive paw ballon" src="../assets/img/icons/yellow-baloon.svg" width="640" height="360" alt="Paw">
              </div>
              <div class="col-md-4  remove-right-padding text-right hidden-md hidden-lg">
                <img class="img-responsive second-image" src="../assets/img/backgrounds/02.webp" width="640" height="360" alt="Second Image">
              </div>
              <div class="col-md-4 second-text">
                <h4 class="text-left">{{translation.homePage.autoCreateTiile}}</h4>
                <div class="text-left">
                  {{translation.homePage.autoCreateMessage}}
                </div>
                  <div class="row">
                    <div class="col-sm-12">
                      <img class="img-responsive paws" src="../assets/img/icons/red-paw.svg" width="640" height="360" alt="Paws">
                    </div>
                  </div>
              </div>
              <div class="col-md-4  remove-right-padding text-right hidden-xs hidden-sm">
                <img class="img-responsive second-image" src="../assets/img/backgrounds/02.webp" width="640" height="360" alt="Second Image">
              </div>
            </div>
          </div>
          <div class="col-sm-12 remove-padding">
            <div class="row">
              <div class="col-md-4 remove-padding third-service text-left">
                <img class="img-responsive" src="../assets/img/backgrounds/03.webp" width="640" height="360" alt="Second Image">
              </div>
              <div class="col-md-4 third-text">
                <h4 class="text-left">{{translation.homePage.lostPetTtile}}</h4>
                <div class="text-right">
                  {{translation.homePage.lostPetMessage}}
                  <p>{{translation.homePage.lostPetMessage2}}</p>
                </div>
                <img class="img-responsive paw" src="../assets/img/icons/yellow-paw.svg" width="640" height="360" alt="Paw">
              </div>
              <div class="col-md-4 text-left">

              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <h3 class="text-center">{{translation.homePage.priceTitle}}</h3>
                <div class="row">
                  <div class="col-sm-4">

                  </div>
                  <div class="price-container col-sm-4">
                    <div class="text-center red-color">
                      {{translation.homePage.freePriceMessage}}
                    </div>
                    <!-- <div class="text-center">
                      <a :href="translation.homePage.boricaUrl" target="_blank"><img :src="translation.homePage.boricaSrc" class="img-responsive" width="640" height="360" alt="Borika" /></a>
                      <img src="../assets/img/logo-en.svg" alt="" style="display: none">
                      <img src="../assets/img/borika-logo.svg" alt="" style="display: none">
                    </div> -->
                  </div>
                  <div class="col-sm-4">

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-1 hidden-xs"></div>
      <div class="col-md-10 hidden-xs presentation">
          <div class="col-md-12 text-center">
            <h3>{{translation.presentation.title}}</h3>
          </div>
          <mdb-carousel
            :interval="4000"
            slide
            :items="basicCarousel"
            indicators
          ></mdb-carousel>
      </div>
      <div class="col-md-1 hidden-xs"></div>
      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-sm-12">
          <div class="row users-vets-reg text-center">
            <h3>{{translation.regis.title}}</h3>
            <div class="col-md-3"></div>
            <div class="col-md-3">
              <img src="../assets/img/icons/user-icon.svg" class="img-responsive" width="640" height="360" alt="User icon" />
              <p>{{users}}</p>
            </div>
            <div class="col-md-3">
              <img src="../assets/img/icons/vet-icon.svg" class="img-responsive" width="640" height="360" alt="Doctor icon" />
              <p>{{doctors}}</p>
            </div>
            <div class="col-md-3"></div>
          </div>
          <div class="row">
            <h3 class="text-center red-color">{{translation.homePage.featureServicesTitle}}</h3>
            <div class="col-md-1"></div>
            <div class="col-md-5 featureServices">
              <h4 class="text-center">{{translation.homePage.featureServicesitle1}}</h4>
              <div class="text-left">
                {{translation.homePage.featureServicesBooking1}}
              </div>
            </div>
            <div class="col-md-5 featureServices">
              <h4 class="text-center">{{translation.homePage.featureServicesitle2}}</h4>
              <div class="text-left">
                {{translation.homePage.featureServicesBooking2}}
              </div>
            </div>
            <div class="col-md-1"></div>
          </div>
        </div>
        <div class="col-md-1"></div>
      </div>
      <Cookies/>
      <div class="home-footer">
        <HomeFooter/>
      </div>
    </div>
</template>
<script>
import Header from '../components/Header.vue'
import HomeFooter from '../components/HomeFooter.vue'
import Cookies from '../components/Cookies.vue'
import { mdbCarousel } from "mdbvue";
export default {
  data(){
    return {
      translation: message,
      cookiesShow: true,
      users: 0,
      doctors: 0,
      carousel: 2,
        basicCarousel: [
          {
            img: true,
            src:
              require("../assets/img/backgrounds/1.webp"),
            mask: "black-light",
            alt: "First Slide",
            width:"640",
            height:"360",
            caption: {
              title: message.homePage.firstSlide
            }
          },
          {
            img: true,
            src:
              require("../assets/img/backgrounds/2.webp"),
            mask: "black-strong",
            width:"640",
            height:"360",
            caption: {
              title: message.homePage.secondSlide
            }
          },
          {
            img: true,
            src:
              require("../assets/img/backgrounds/3.webp"),
            mask: "black-slight",
            width:"640",
            height:"360",
            caption: {
              title: message.homePage.thirdSlide
            }
          },
          {
            img: true,
            src:
              require("../assets/img/backgrounds/4-1.webp"),
            mask: "black-slight",
            width:"640",
            height:"360",
            caption: {
              title: message.homePage.fourSlide
            }
          }
        ]
    }
  },
  components: {
    Header,
    HomeFooter,
    mdbCarousel,
    Cookies
  },
  created(){
    var self = this;
    console.log('#Home app');
    this.$bus.$on('language', () => {
      this.translation = window.message;
    });
    if(localStorage.getItem('userLoggedIn')){
      if (self.$route.name == 'home') {
        self.$router.push({ name: 'user-home-page', params: { lang: window.lang } })
      }
    }else if(localStorage.getItem('doctorLoggedIn')){
      if (self.$route.name == 'home') {
        self.$router.push({ name: 'doctor-home', params: { lang: window.lang } })
      }
    }else {
      axios.get('get-users-and-vets')
      .then(function (response){
        self.users = response.data.result.usersCount;
        self.doctors = response.data.result.doctorsCount;
      })
    }
  },
  methods: {
  }
}
</script>

<style>
@font-face {
  font-family: 'Montserrat-Black';
  src: url("../assets/fonts/Montserrat-Black.woff") format("woff");
  font-display: swap;
}
#home{
  background: #FFF;
}
#home h3, #home h4 {
  font-family: 'Montserrat-Black', sans-serif;
  margin-bottom: 1em;
  color: #3057B0;
  margin-top: 3em;
  font-size: 1.3em;
}
#home .users-vets-reg img {
  height: 10em;
}
#home .users-vets-reg p {
  font-size: 2em;
  margin-top: 1em;
  color: #FE7154;
  font-weight: bold;
}
.carousel-indicators .active{
  background-color: #3057B0;
}
.carousel-indicators li{
  border: 1px solid #3057B0;
}
.item img{
  width: 100%;
}
#home .paragraf, .presentation-video {
  margin-bottom: 2em;
  margin-top: 1em;
}
#home .services {
  padding: 0;
}
#home .see-vets {
  background: #FDD84C;
  color: #3057B0;
  font-family: 'Montserrat-Black', sans-serif;
  display: inline-block;
  margin-top: 2em;
  margin-bottom: 2em;
  padding: 3em;
  padding-top: 1em;
  padding-bottom: 1em;
  border-radius: 5em;
  border: 2px solid #3057B0;
  text-decoration: none;
}
#home .first-paw{
  margin-bottom: 2em;
}
#home .services img{
  width: 100%;
}
{
  width: 15em;
}
#home .services .second-service img{
  width: 20em;
}
#home .services .second-service .ballon{
  width: 5em;
}
#home .services .second-text img{
  width: 5em;
}
#home .first-paw .paw,
#home .services .paw {
  margin-bottom: 2em;
  margin-top: 2em;
  width:5em;
}
#home .paws {
  width: 12em;
  padding-top: 2em;
  text-align: right;
}
#home .remove-right-padding {
  padding-right: 0;
}
#home .second-image{
  display: inline-block;
}
#home .remove-padding{
  padding: 0;
}
#home .red-color{
  color: #FE7154;
}
.presentation-video-presentation iframe{
  min-width: 100%!important;
  height: 35em!important;
}
.presentation-video,.presentation-video video{
  width: 100%;
}
.presentation iframe{
  min-width: 100%!important;
  height: 25em!important;
}
#home .featureServices h3{
  font-size: 1.5em;
}
#home .services .second-text .blue-paws {
  width: 60%;
  margin-top: 1em;
}
@media (max-width: 1590px) {
  #header .hiden-menu-mobile span{
    margin-right: .3em;
  }
  #header .login-registration-links{
    margin-left: 0em;
  }
}
@media (max-width: 1412px) {
  #home .services .second-service .ballon{
    display: none;
  }
  #home .services .blue-paws{
    display: none;
  }
}
@media (max-width: 600px) {
  .presentation-video-presentation iframe{
    min-width: 100%!important;
    height: 15em!important;
  }
  .presentation iframe{
    min-width: 100%!important;
    height: 15em!important;
  }
}
</style>
